/**
 * Allowlist of CDN signing query-param names that we propagate from a
 * pre-signed `previewCdnUrl` onto the URL produced by `getImageUrlSync`.
 * These are the standard CloudFront signed-URL params; if the upstream
 * adds a new one, this list needs updating.
 */
const SIGNING_PARAM_NAMES = ['token', 'Policy', 'Key-Pair-Id', 'Signature', 'Expires'] as const;

/**
 * Pull the CDN-signing query params (token / Policy / Key-Pair-Id / Signature
 * / Expires) out of a pre-signed CDN URL so they can be overlaid on a URL
 * built independently by `getImageUrlSync` (which constructs path, image
 * params, pathBased routing, wmv, etc.). Image-shape params from the cdn URL
 * itself (width/height/mode/...) are intentionally NOT extracted — those come
 * from `imageURLParams` via `getImageUrlSync`.
 *
 * Returns `{}` on parse failure so we degrade rather than throw.
 */
export const extractCdnSigningParams = (cdnUrl: string): Record<string, string> => {
	try {
		const url = new URL(cdnUrl);
		const out: Record<string, string> = {};
		for (const name of SIGNING_PARAM_NAMES) {
			const value = url.searchParams.get(name);
			if (value !== null) {
				out[name] = value;
			}
		}
		return out;
	} catch {
		return {};
	}
};
